import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from "@angular/router";
import {FormGeneratorDataListComponent} from './form-generator-data-list/form-generator-data-list.component';
import {CtModelModule} from "@ctsolution/ct-framework";
import {MatLegacyButtonModule} from "@angular/material/legacy-button";
import {MatLegacyMenuModule} from "@angular/material/legacy-menu";
import {MatIconModule} from "@angular/material/icon";
import { FormGeneratorDataEditComponent } from './form-generator-data-edit/form-generator-data-edit.component';
import { FormGeneratorDataEditModule } from './form-generator-data-edit/form-generator-data-edit.module';

@NgModule({
  declarations: [
    FormGeneratorDataListComponent,
  ],
  imports: [
    CommonModule,
    FormGeneratorDataEditModule,
    RouterModule.forChild([
      {
        path: "",
        children: [
          {
            path: "",
            redirectTo: "list",
            pathMatch: "full"
          },
          {
            path: "list",
            component: FormGeneratorDataListComponent
          },
          {
            path: "edit/:id",
            component: FormGeneratorDataEditComponent
          }
        ]
      }
    ]),
    CtModelModule,
    MatLegacyButtonModule,
    MatLegacyMenuModule,
    MatIconModule,
  ]
})
export class FormGeneratorDataModule {
}
